export default __webpack_public_path__ + "static/media/Copy of the-key-to-encryption.0087640f.jpg";